<template>
  <el-drawer :visible.sync="dialogShow" :before-close="closeDialog" direction="btt" :with-header="false">
    <!-- <el-form ref="form" :model="form">
      <el-form-item>
        <el-input v-model="form.input" placeholder="请输入内容">
          <el-button
            type="primary"
            slot="append"
            icon="el-icon-search"
            @click="search"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form> -->
    <el-table :data="items" style="width: 100%;" :row-style="{height:'0'}" :cell-style="{padding:'0'}" :show-header="false">
      <el-table-column prop="kpName" align="left"> </el-table-column>
      <el-table-column align="center">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text"
            >选择</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </el-drawer>
</template>

<script>
import { Invoice } from "@/store/entity/invoice";
export default {
  components: {},
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    item: {
      type: String,
    },
  },
  data() {
    return {
      form: {
        input: "",
      },
      dialogShow: false,
      dialogObj: {
        width: "20%",
        center: true,
      },
      items: [],
    };
  },

  watch: {
    dialog: {
      handler() {
        this.dialogShow = this.dialog;
      },
      immediate: true,
    },
    item: {
      async handler() {
        this.items = [];
        if (this.item) {
          this.form.input = this.item;
          const res = await Invoice.getTaxno(this.item);
          if (res && res.msg) {
            this.items = [...res.msg];
          }
          //this.items.unshift({ kpName: this.form.input });
        }
      },
    },
  },
  methods: {
    closeDialog() {
      this.dialogShow = false;
      this.$emit("closeghdwmcSelectDialog");
    },
    async search() {
      this.items = [];
      const res = await Invoice.getTaxno(this.form.input);
      if (res && res.msg) {
        this.items = [...res.msg];
      }
      this.items.unshift({ kpName: this.form.input });
    },
    handleClick(item) {
      this.$emit('selectghdwmc',item)
      this.form.input = item.kpName
    },
  },
};
</script>

<style lang="scss" scoped>
</style>